import { EDashColors } from "@/features/financas/views/Indicadores/@types/enums";
import { IShortcut } from "@/core/composables/Shortcuts/Shortcut";
import type {
  IF360Currency,
  TCurrencyValue
} from "@/core/plugins/currency.js/types";
import {
  EGoupReturnBy,
  ERequestedKPI,
  IFilterParams,
  IFilterParamsDesempenhoVendas
} from "@/features/financas/views/Indicadores/services/types";
import { IIndicadoresParams } from "./types";
import { inject, injectable } from "inversify";
import { DITypes } from "@/core/@types/types";
import { EShortcutTypeChart } from "@/features/financas/views/Indicadores/components/dialog/types";

@injectable()
export default class IndicadoresParams implements IIndicadoresParams {
  @inject(DITypes.CURRENCY)
  currency!: IF360Currency;

  constructor() {
    this.colors = [
      EDashColors.blue,
      EDashColors.ciano,
      EDashColors.purple,
      EDashColors.yellow,
      EDashColors.orange,
      EDashColors.green,
      EDashColors.brown,
      EDashColors.pink,
      EDashColors.lightGray,
      EDashColors.darkBlueTwo,
      EDashColors.neonRed,
      EDashColors.lightPurple,
      EDashColors.lightYellow,
      EDashColors.lightPurple,
      EDashColors.white
    ];

    this.colorsCards = [
      EDashColors.blue,
      EDashColors.green,
      EDashColors.gray,
      EDashColors.red
    ];
  }

  readonly colors;
  readonly colorsCards;
  formatter!: (value: TCurrencyValue) => string;

  setFormat(format: (value: TCurrencyValue) => string) {
    this.formatter = format;
  }

  getColors() {
    try {
      const colorList = JSON.stringify(this.colors);

      return JSON.parse(colorList) as EDashColors[];
    } catch (_e) {
      console.log("erro indicadores params");

      return [];
    }
  }

  getFilter(
    requestedKPI: ERequestedKPI,
    filter: IShortcut,
    type?: EGoupReturnBy
  ): IFilterParams {
    const initialFilter = Object.assign({}, filter) as IFilterParams;
    initialFilter.groupReturnBy = type || EGoupReturnBy.Day;
    initialFilter.requestedKPI = requestedKPI;
    initialFilter.targetWidget = "All";

    return initialFilter;
  }

  getFilterDesempenhoVendas(
    requestedKPI: ERequestedKPI,
    filter: IShortcut,
    type?: EGoupReturnBy
  ): IFilterParamsDesempenhoVendas {
    const initialFilter = Object.assign(
      {},
      filter
    ) as IFilterParamsDesempenhoVendas;
    initialFilter.groupReturnBy = type || EGoupReturnBy.Day;
    initialFilter.requestedKPI = requestedKPI;
    initialFilter.targetWidget = "All";

    return initialFilter;
  }

  formatterMoney(value: TCurrencyValue): string {
    const money = this.currency.toMoney(value);
    const amount = this.formatter(money);

    return amount;
  }

  formatterMoneyRaw(value: TCurrencyValue): string {
    const money = this.currency.toMoney(value);

    return money;
  }

  formatterDate(value: string): string {
    const money = this.currency.toMoney(value);
    const amount = this.formatter(money);

    return amount;
  }

  getGroupReturnByCharts(type: EShortcutTypeChart) {
    const shortcutsNames = new Map<EShortcutTypeChart, EGoupReturnBy>([
      [EShortcutTypeChart.tempo, EGoupReturnBy.Day],
      [EShortcutTypeChart.Modalidade, EGoupReturnBy.Modality],
      [EShortcutTypeChart.Empresa, EGoupReturnBy.Store],
      [EShortcutTypeChart.ModalidadeTempo, EGoupReturnBy.DayModality],
      [EShortcutTypeChart.EmpresaTempo, EGoupReturnBy.DayStore],
      [EShortcutTypeChart.ModalidadeEmpresa, EGoupReturnBy.StoreModality],
      [EShortcutTypeChart.ModalidadeDetalhada, EGoupReturnBy.ModalityDetails],
      [EShortcutTypeChart.Adquirentes, EGoupReturnBy.Adquirentes]
    ]);

    return shortcutsNames.get(type);
  }

  addSeparator(value: TCurrencyValue) {
    const money = this.currency.addSeparatorNumber(value);

    return money;
  }
}
